<div class="row" [hidden]="psnbs.selectedNavBarSection == 6">
    <div class="col-12 bg-babyShark" [hidden]="!(psnbs.selectedNavBarSection > 0)">
        <div class="d-flex align-items-center justify-content-center mmPointStoreNavigationBar" >
            <div class="d-flex flex-row flex-wrap">
                <div class="d-flex align-items-center stepper-cv mr-4" (click)="setEditFrame(1)">
                    <div class="circle" [ngClass]="psnbs.selectedNavBarSection == 1 ? 'active' : 'inactive'">1</div>
                    <div class="steps px-2" [ngClass]="psnbs.selectedNavBarSection == 1 ? 'active' : 'inactive'"><span
                            cvLocalizedText langSection="MarketPlace_Management" langKey="Product_Info">Product
                            Info</span>
                    </div>
                    <div class="line"></div>
                </div>
                <div class="d-flex align-items-center stepper-cv mr-4" (click)="setEditFrame(2)">
                    <div class="circle" [ngClass]="psnbs.selectedNavBarSection == 2 ? 'active' : 'inactive'">2</div>
                    <div class="steps px-2" [ngClass]="psnbs.selectedNavBarSection == 2 ? 'active' : 'inactive'"><span
                            cvLocalizedText langSection="MarketPlace_Management" langKey="Display_Settings">Display
                            Settings</span> </div>
                    <div class="line"></div>
                </div>
                <div class="d-flex align-items-center stepper-cv mr-4" (click)="setEditFrame(3)">
                    <div class="circle" [ngClass]="psnbs.selectedNavBarSection == 3 ? 'active' : 'inactive'">3</div>
                    <div class="steps px-2" [ngClass]="psnbs.selectedNavBarSection == 3 ? 'active' : 'inactive'"><span
                            cvLocalizedText langSection="MarketPlace_Management" langKey="Upload_Picture">Upload
                            Picture</span></div>
                    <div class="line"></div>
                </div>
                <div class="d-flex align-items-center stepper-cv mr-4" (click)="setEditFrame(4)">
                    <div class="circle" [ngClass]="psnbs.selectedNavBarSection == 4 ? 'active' : 'inactive'">4</div>
                    <div class="steps px-2" [ngClass]="psnbs.selectedNavBarSection == 4 ? 'active' : 'inactive'"><span
                            cvLocalizedText langSection="MarketPlace_Management" langKey="Assign_Groups">Assign
                            Groups</span></div>
                    <div class="line"></div>
                </div>
                <div class="d-flex align-items-center stepper-cv mr-4" (click)="setEditFrame(5)">
                    <div class="circle" [ngClass]="psnbs.selectedNavBarSection == 5 ? 'active' : 'inactive'">5</div>
                    <div class="steps px-2" [ngClass]="psnbs.selectedNavBarSection == 5 ? 'active' : 'inactive'"><span
                            cvLocalizedText langSection="MarketPlace_Management" langKey="Summary">Summary</span></div>
                </div>
                <div *ngIf="false">
                    <div class="d-flex align-items-center stepper-cv " (click)="setEditFrame(0)">
                        <div class="circle" [ngClass]="psnbs.selectedNavBarSection == 0 ? 'active' : 'inactive'">0</div>
                        <div class="steps px-2" [ngClass]="psnbs.selectedNavBarSection == 0 ? 'active' : 'inactive'">
                            LandingPage
                        </div>
                    </div>
                </div>
                <div *ngIf="false" class="clear"></div>
            </div>
        </div>

    </div>
</div>